export default {"src":"/_next/static/media/walking-bridge-sm.mono.edad3eff.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};